import YwIcon from "./src/index.vue";
YwIcon.install = function (Vue) {
	Vue.component(YwIcon.name, YwIcon);
};

export default YwIcon;
